import { motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';

import { Quote, QuoteWrapper, Wrapper } from './QuoteLoop.styles';

const QuoteLoop = ({ quote }) => {
  const ref = useRef();
  const [isScrollActive, setIsScrollActive] = useState(false);
  const [fromBottom, setFromBottom] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const updateFromBottomDistance = () => {
      if (!ref.current) return;
      const el = ref.current.getBoundingClientRect();
      const toBottom = el.top - window.innerHeight - el.height;

      setFromBottom(toBottom);
      setIsScrollActive(toBottom <= 0);
    };

    window.addEventListener('scroll', updateFromBottomDistance);
    return () => window.removeEventListener('scroll', updateFromBottomDistance);
  }, [ref]);

  return (
    <Wrapper ref={ref}>
      <motion.div
        animate={{
          x: isScrollActive ? fromBottom / 2 : 0,
          transition: {
            ease: [0.165, 0.84, 0.44, 1],
            duration: 0.1,
          },
        }}
      >
        <QuoteWrapper>
          {[...Array(10)].map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Quote key={index}>{quote}</Quote>
          ))}
        </QuoteWrapper>
      </motion.div>
    </Wrapper>
  );
};

export default QuoteLoop;
